// extracted by css-extract-rspack-plugin
export default {"root":"styles_root__brqDB","body2":"styles_body2__nzwZs","seperator":"styles_seperator__HlosP","approved":"styles_approved__x7BT-","rejected":"styles_rejected__aWDPM"};